package net.maraclinic.app.theme

import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.rgb

object Theme {

    enum class Mode {
        Light, Dark;

        val isLight get() = this == Light
        val isDark get() = this == Dark
    }

    object LightColors {
        val Primary = Color("#bd9854")
        val OnPrimary = Color("#473100")

        val Secondary = Color("#f7dfbb")
        val OnSecondary = Color("#736245")

        val Surface = Color("#f5ece4")
        val OnSurface = Color("#4e4639")

        val Background = Color("#fff8f3")
        val OnBackground = Color("#1e1b16")
    }

    object DarkColors {
        val Primary = Color("#bd9854")
        val OnPrimary = Color("#473100")

        val Secondary = Color("#54452a")
        val OnSecondary = Color("#c7b291")

        val Surface = Color("#231f1a")
        val OnSurface = Color("#d1c5b4")

        val Background = Color("#16130e")
        val OnBackground = Color("#e9e1d9")
    }

}